export class AgendaElements {
  constructor(agenda) {
    this.agenda = agenda;
    this.items = agenda.querySelectorAll(".agenda-overview-item");
    this.months = agenda.querySelectorAll(".agenda-overview__month");
    this.filterMonths = agenda.querySelectorAll(
      ".agenda-overview-filter__month.d-block"
    );
    this.noItems = agenda.querySelector(".agenda-overview-no-items");
    this.filter = agenda.querySelector(".agenda-overview-filter");
    this.filterInner = agenda.querySelector(".agenda-overview-filter__inner");
    this.chevronLeft = agenda.querySelector(
      ".agenda-overview-filter__chevron--left"
    );
    this.chevronRight = agenda.querySelector(
      ".agenda-overview-filter__chevron--right"
    );
    this.search = agenda.querySelector(".agenda-overview-search");
    this.categories = agenda.querySelector(".agenda-overview-categories");
    this.locations = agenda.querySelector(".agenda-overview-locations");
  }
}
